export default __webpack_public_path__ + "static/media/543386__nillyplays__nom-noise.b61864ec.mp3";